import React, { useState } from 'react';
import { postDemoRequest } from '@/lib/api';

export default function BookDemo() {
  const [form, setForm] = useState({
    full_name: '',
    work_email: '',
    company: '',
    role: '',
    phone: '',
    website: '',
    monthly_ad_spend: '',
    message: '',
  });
  const [status, setStatus] = useState('idle');
  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    try {
      await postDemoRequest({ ...form, source: 'book-a-demo' });
      setStatus('done');
      setForm({ full_name: '', work_email: '', company: '', role: '', phone: '', website: '', monthly_ad_spend: '', message: '' });
    } catch (err) {
      setStatus('error');
    }
  };

  return (
    <section className="pt-20 pb-16 border-b border-[#1a1a1a] hero-grid diag-lines inner-hero">
    <div className="container-r360 py-20 min-h-[80vh]" data-testid="book-demo-page">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
        <div className="lg:col-span-6">
          <div className="highlights-kicker text-blue">
            <span />
          BOOK A STRATEGY CALL
          </div>
          <h1 className="font-display font-bold leading-[0.92] tracking-[-0.035em] text-[70px] sm:text-[4rem] md:text-[5.5rem] lg:text-[6.5rem]">
            30-MIN CALL. <span className="accent">A CUSTOM PLAN.</span>
          </h1>
          <p className=" text-[17px] text-[#c9c9c9] font-bold leading-relaxed mt-8">
            We'll review your current retargeting stack, model your recoverable revenue, and architect a CPS campaign built to outperform your current CPM program by day 60.
          </p>
          <ul className="mt-10 space-y-6 reveal-on-scroll">
            {[
              { t: 'No sales pitch', b: 'A working session with an adtech strategist.' },
              { t: 'Live in 48 hours', b: 'Single-tag install. No engineering sprint.' },
              { t: 'Zero-risk', b: 'You pay only on verified sales.' },
            ].map((it, i) => (
              <li key={i} className="flex gap-4">
                <span className="w-6 h-6 border border-[#22d07a] text-[#22d07a] flex items-center justify-center font-mono text-[15px] flex-shrink-0 mt-1">✓</span>
                <div>
                  <div className="font-sans font-extrabold text-[17px] text-green">{it.t}</div>
                  <div className="text-[15px] text-[#f0f0f0]">{it.b}</div>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <form onSubmit={submit} className="reveal-on-scroll lg:col-span-6 border border-[#1a1a1a] bg-[#0b0b0b] p-8 lg:p-12" data-testid="book-demo-form">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div>
              <label className="field-label">FULL NAME *</label>
              <input required className="field-input" value={form.full_name} onChange={onChange('full_name')} data-testid="demo-fullname" />
            </div>
            <div>
              <label className="field-label">WORK EMAIL *</label>
              <input required type="email" className="field-input" value={form.work_email} onChange={onChange('work_email')} data-testid="demo-email" />
            </div>
            <div>
              <label className="field-label">COMPANY *</label>
              <input required className="field-input" value={form.company} onChange={onChange('company')} data-testid="demo-company" />
            </div>
            <div>
              <label className="field-label">YOUR ROLE</label>
              <input className="field-input" placeholder="CMO, Head of Performance…" value={form.role} onChange={onChange('role')} data-testid="demo-role" />
            </div>
            <div>
              <label className="field-label">PHONE</label>
              <input className="field-input" value={form.phone} onChange={onChange('phone')} data-testid="demo-phone" />
            </div>
            <div>
              <label className="field-label">WEBSITE</label>
              <input className="field-input" placeholder="company.com" value={form.website} onChange={onChange('website')} data-testid="demo-website" />
            </div>
            <div className="sm:col-span-2">
              <label className="field-label">MONTHLY AD SPEND (APPROX.)</label>
              <input className="field-input" placeholder="$50K — $500K" value={form.monthly_ad_spend} onChange={onChange('monthly_ad_spend')} data-testid="demo-spend" />
            </div>
            <div className="sm:col-span-2">
              <label className="field-label">WHAT ARE YOU TRYING TO SOLVE?</label>
              <textarea rows={3} className="field-textarea" placeholder="Cart abandonment, CPM waste, attribution, etc." value={form.message} onChange={onChange('message')} data-testid="demo-message" />
            </div>
          </div>

          <div className="mt-10 gap-4">
            <button type="submit" disabled={status === 'loading'} className="btn btn-primary disabled:opacity-60" data-testid="demo-submit">
              {status === 'loading' ? 'Sending…' : 'Book the call →'}
            </button>
            <div className="mono-label text-[#5a5a5a] mt-3">WE REPLY WITHIN 24 HOURS.</div>
          </div>
          {status === 'done' && (
            <div className="mt-8 border border-[#22d07a] bg-[#0a1a10] text-[#22d07a] p-5 font-mono text-[13px]" data-testid="demo-success">
              ✓ REQUEST RECEIVED — A STRATEGIST WILL BE IN TOUCH WITHIN 24 HOURS.
            </div>
          )}
          {status === 'error' && (
            <div className="mt-8 border border-red-500 bg-[#1a0a0a] text-red-500 p-5 font-mono text-[13px]">
              ✗ SOMETHING WENT WRONG. PLEASE TRY AGAIN OR EMAIL HELLO@RETARGET360.AI.
            </div>
          )}
        </form>
      </div>
    </div>
    </section>
  );
}
